import { Box, styled, Typography } from '@mui/material';
import { noImageBorderColor } from 'themes/colors';

export const StyledBox = styled(Box)`
  background: linear-gradient(to right, ${noImageBorderColor} 50%, transparent 0%) top repeat-x,
    linear-gradient(${noImageBorderColor} 50%, transparent 0%) right repeat-y,
    linear-gradient(to right, ${noImageBorderColor} 50%, transparent 0%) bottom repeat-x,
    linear-gradient(${noImageBorderColor} 50%, transparent 0%) left repeat-y;
  background-size: 22px 2px, 2px 22px;
  border-radius: 8px;
  display: flex;
  padding: 32px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  max-height: 500px;
  margin: 0;
`;

export const StyledTypography = styled(Typography)`
  color: #6b7280;
  font-weight: 500;
  font-size: 1rem;
  margin-top: 10px;
`;
